import * as React from 'react';

import { ITermsOfUseCardAcceptanceProps } from '../models/types';
import { useGetAgreementAuthenticated } from '../hooks/useGetAgreement';
import { TermsOfUseCard } from './TermsOfUseCard';

export const TermsOfUseCardAuth: React.FC<ITermsOfUseCardAcceptanceProps> = (props) => {
  const getAgreementQuery = useGetAgreementAuthenticated(props.agreementId);

  return <TermsOfUseCard getAgreementQuery={getAgreementQuery} isAnonymousPage={false} {...props} />;
};
